<template>
  <section class="section--comp">
    <div class="container items-center mb-5rem lg:w-3/4 pb-base">
      <h3 class="section--h3 text-4xl">Drivers of effective learning</h3>
      <p class="section--p text-base">4 drivers of our training need analysis</p>
      <vs-row class="personality-row" vs-type="flex">
        <vs-col class="sm:w-full md:w-1/2 lg:w-1/4 p-3" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-2 mb-2 items-center">
            <div class="mt-3 mb-3" slot="media">
              <!--span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-danger),0.15);"
              -->
                <img src="../../../../../src/assets/images/demo/customize_need.svg" alt="p.title" width="82px" height="82px" />
            </div>
            <div class="items-center mb-0">
              <h4 class="feature-title mb-3">Need</h4>
              <p class="feature-description">Does the employee need training?</p>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full md:w-1/2 lg:w-1/4 p-3" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-2 mb-2 items-center">
            <div class="mt-3 mb-3" slot="media">
              <!--span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-danger),0.15);"
              -->
                <img src="../../../../../src/assets/images/demo/customize_want.svg" alt="p.title" width="82px" height="82px" />
              <!--/span-->
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Want</h4>
              <p class="feature-description">Does the employee want it?</p>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full md:w-1/2 lg:w-1/4 p-3" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-2 mb-2 items-center">
            <div class="mt-3 mb-3" slot="media">
              <!--span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-danger),0.15);"
              -->
                <img src="../../../../../src/assets/images/demo/customize_access.svg" alt="p.title" width="82px" height="82px" />
              <!--/span-->
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Access</h4>
              <p class="feature-description">Do they have access to the relevant learning material?</p>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full md:w-1/2 lg:w-1/4 p-3" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-2 mb-2 items-center">
            <div class="mt-3 mb-3" slot="media">
              <!--span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-danger),0.15);"
              -->
                <img src="../../../../../src/assets/images/demo/customize_application.svg" alt="p.title" width="82px" height="82px" />
              <!--/span-->
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Application</h4>
              <p class="feature-description">Will the employee be able to apply that knowledge?</p>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
    <div class="container items-left lg:w-3/4 pt-base">
      <h3 class="section--h3 mb-5 text-4xl">5th Dimension being Time</h3>
      <vx-card no-shadow card-background="#F7F8F9">
        <div class="tips-heading mb-base">5 Tips to Engage Learners in the attention starved world</div>
        <ul class="tips-list">
          <li><vs-icon class="mr-3" color="#FBA727" icon="icon-check-circle" icon-pack="feather"/>Package microlearning as you would a social media post—“on-demand, engaging, and media- rich.”</li>
          <li><vs-icon class="mr-3" color="#FBA727" icon="icon-check-circle" icon-pack="feather"/>Use interactive learning strategies (gamified learning, scenario-based, interactive pdfs, videos, and infographics)</li>
          <li><vs-icon class="mr-3" color="#FBA727" icon="icon-check-circle" icon-pack="feather"/>Consciously build a shared learning culture with these tips from It’s Time to Change How You Design Training eBook.</li>
          <li><vs-icon class="mr-3" color="#FBA727" icon="icon-check-circle" icon-pack="feather"/>Modern learners are also increasingly social learners because they learn from their networks.</li>
          <li><vs-icon class="mr-3" color="#FBA727" icon="icon-check-circle" icon-pack="feather"/>Create reflection and discussion groups for learners to network and grow from each other.</li>
        </ul>
      </vx-card>
    </div>
  </section>
</template>

<script>
  export default {
    name: "EffectiveLearning"
  }
</script>

<style scoped>
  .mb-5rem {
    margin-bottom: 5rem;
  }
  section {
    padding: 7rem 0;
  }
  .con-vs-card {
   min-height: 250px;
  }
  .tips-heading {
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;
    color: #231D4F;
  }

  .tips-list li {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #231D4F;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 20px 0px;
  }

  .feature-title {
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
    /*margin: 0px 10px;*/
  }

  .feature-description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    /*margin: 0px 10px;*/
  }


  @media (max-width: 1200px) {
    section {
      padding: 7rem 0;
    }
  }
</style>
